import loadable from '@loadable/component';

/* istanbul ignore next */
export const NewbuildingBrokerRequestExistsModalLoadable = loadable(
  () =>
    import('@cian/frontend-newbuilding-broker-callback-component').catch(() => ({ RequestExistsModal: () => null })),
  {
    resolveComponent: ({ RequestExistsModal }) => RequestExistsModal,
    ssr: false,
  },
);
